import { StatementType } from "./index.js";
import { isCommaToken, isDefaultValue, isEqualToken, isGoValue, isNewStatement, isNullValue, isSemicolonToken, isStringToken, matchAddExtendedProperty } from "../helper.js";
//#region ../schema-sql-parser/dist/parser/statement/add.extended.property.js
var Parameters = [
	"@NAME",
	"@VALUE",
	"@LEVEL0TYPE",
	"@LEVEL0NAME",
	"@LEVEL1TYPE",
	"@LEVEL1NAME",
	"@LEVEL2TYPE",
	"@LEVEL2NAME"
];
var ReadParameters = Parameters.filter((parameter) => !parameter.startsWith("@LEVEL0"));
var isVariable = (token) => !!token && !token.quoted && token.value[0] === "@";
var isOperator = (token) => !!token && !token.quoted && /^[-+*/%&|^]/.test(token.value);
function addExtendedPropertyParser(tokens, $pos) {
	const isString = isStringToken(tokens);
	const isEqual = isEqualToken(tokens);
	const isComma = isCommaToken(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isNull = isNullValue(tokens);
	const isDefault = isDefaultValue(tokens);
	const isGo = isGoValue(tokens);
	const newStatement = isNewStatement(tokens);
	const isArgument = (pos) => isString(pos) && !isGo(pos) && !newStatement(pos);
	const args = /* @__PURE__ */ new Map();
	const call = matchAddExtendedProperty(tokens)($pos.value);
	if (!call) {
		$pos.value++;
		return null;
	}
	$pos.value += call;
	for (let index = 0; isArgument($pos.value); index++) {
		const token = tokens[$pos.value];
		let parameter = Parameters[index] ?? "";
		if (isVariable(token) && isEqual($pos.value + 1)) {
			parameter = token.value.toUpperCase();
			$pos.value += 2;
			if (!isArgument($pos.value)) break;
		}
		if (!isNull($pos.value) && !isDefault($pos.value)) args.set(parameter, tokens[$pos.value]);
		$pos.value++;
		if (isOperator(tokens[$pos.value])) return null;
		if (!isComma($pos.value)) break;
		$pos.value++;
	}
	if (isSemicolon($pos.value)) $pos.value++;
	return toComment(args);
}
function toComment(args) {
	if (ReadParameters.some((parameter) => isVariable(args.get(parameter)))) return null;
	const nameOf = (parameter) => args.get(parameter)?.value ?? "";
	const value = args.get("@VALUE");
	const tableName = nameOf("@LEVEL1NAME");
	const level2type = nameOf("@LEVEL2TYPE").toUpperCase();
	const columnName = nameOf("@LEVEL2NAME");
	if (nameOf("@NAME").toUpperCase() !== "MS_DESCRIPTION" || value?.quoted !== "'" || nameOf("@LEVEL1TYPE").toUpperCase() !== "TABLE" || !tableName) return null;
	if (!level2type) return {
		type: StatementType.commentOnTable,
		name: tableName,
		comment: value.value
	};
	if (level2type !== "COLUMN" || !columnName) return null;
	return {
		type: StatementType.commentOnColumn,
		tableName,
		columnName,
		comment: value.value
	};
}
//#endregion
export { addExtendedPropertyParser };
